<template>
    <!--<div :style="style(name)">-->
    <!--</div>-->
    <div class="container" v-show="isVisible" ref="container">
        <div v-if="src.type=='video'">
            <video autoplay muted playsinline ref="video">
            </video>
        </div>

        <div v-if="src.type=='image'">
            <div ref="image" :class="{image:true, 'image-ie':isIE}"></div>
        </div>
    </div>
</template>

<script>

    import detect from 'detect-browser';

    export default {
        name: "JumboImage",
        props: ['src', 'index'],
        data() {
            return {
                zindex: 100,
                isVisible: false,
                transition: {'width': 0},
                mediaLoaded: false,
                image: new Image(),
                inv: null,
                progress: 0,
                isIE: detect.detect().name == 'ie'
            }
        },

        methods: {
            /* style(name) {
                 const url = require(`../assets/projects/${name}`);
                 return {
                     'height': '100vh',
                     'background-size': 'cover',
                     'background-position': 'center',
                     'background-color': 'black',
                     'background-image': `url(${url})`
                 }
             },*/
            showImage() {
                this.$refs.container.style = {width: '100vw'};
                // this.$refs.image.style.backgroundImage = `url(${url})`;
                this.$refs.image.style.backgroundImage = `url(${this.image.src})`;
                this.isVisible = true;
                if (this.oldSlide) {
                    this.oldSlide.hide();
                }
                const duration = 4;

                // setTimeout(() => {
                //     this.$emit('next');
                // }, duration);
                this.progress = 0;

                TweenLite.to(this, duration, {
                    progress: 100,
                    ease: Linear.easeNone,
                    onUpdate: () => {
                        this.$emit('progress', this.progress);
                    },
                    onComplete: () => {
                        this.$emit('next');
                    }
                });
            },
            showVideo() {
                this.$refs.container.style = {width: '100vw'};
                this.isVisible = true;
                if (this.oldSlide) {
                    this.oldSlide.hide();
                }
                clearInterval(this.inv);
                this.inv = setInterval(() => {
                    const p = this.$refs.video.currentTime * 100 / this.$refs.video.duration;
                    this.$emit('progress', p);
                }, 30);
            },
            show(oldSlide) {
                // console.log(this);
                const url = `/img/projects/${this.src.name}`;
                this.oldSlide = oldSlide;
                // console.log(url, this.src, this.mediaLoaded);

                clearInterval(this.inv);

                if (this.src.type == 'image') {
                    if (!this.mediaLoaded) {
                        this.image.onload = () => {
                            this.mediaLoaded = true;
                            this.showImage(url);
                            this.$bus.$emit('loaded');
                        };
                        this.image.src = url;
                    } else {
                        this.showImage(url);
                    }
                } else {
                    this.$refs.video.src = url;
                    const promise = this.$refs.video.play();
                    if (promise) {
                        promise.then(_ => {

                        }).catch(error => {
                            setTimeout(() => {
                                this.$emit('next');
                            }, 2000);
                        });
                    }
                }
            },
            hide() {
                this.$parent.$el.append(this.$el);

                TweenLite.to(this.$refs.container, 0.4, {
                    width: 0, onComplete: () => {
                        this.isVisible = false;
                    }, ease: Sine.easeInOut
                })
            }
        },
        mounted() {
            this.isVisible = this.isIE;
            const video = this.$refs.video;
            if (video) {
                video.muted = true;
                video.addEventListener('ended', () => {
                    clearInterval(this.inv);
                    this.$emit('next');
                });

                // video.addEventListener('timeupdate', () => {
                //     const p = video.currentTime * 100 / video.duration;
                //     this.$emit('progress', p);
                // });
                video.addEventListener('canplay', () => {
                    this.showVideo();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    video {
        height: 100%;
        width: 177.77777778vh; /* 100 * 16 / 9 */
        min-width: 100%;
        min-height: 56.25vw; /* 100 * 9 / 16 */
        position: absolute;
        left: 50%; /* % of surrounding element */
        top: 50%;
        transform: translate(-50%, -50%); /* % of current element */
        background-color: black;
    }

    .image {
        height: 100vh;
        background-size: cover;
        background-position: center;

    }

    .image-ie {
        background-image: url(/img/projects/maximalaufgeladen01.jpg);
    }

    .container {
        overflow: hidden;
        position: relative;
        width: 100vw;
        height: 100vh;
        background-color: black;

    }
</style>